export default function (props: any) {
    return (
        <svg width="58px" height="59px" viewBox="0 0 58 59" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-741.000000, -7898.000000)">
                    <g transform="translate(741.000000, 7898.493000)">
                        <rect x="0" y="0" width="58" height="58"></rect>
                        <g transform="translate(4.860500, 11.142217)" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7765">
                            <path d="M3.22273207,29.6996696 L3.22273207,2.28552487 C3.22273207,1.02346482 4.20550913,0 5.418154,0 L42.7237321,0 C43.9363769,0 44.919154,1.02346482 44.919154,2.28552487 L44.919154,29.6996696"></path>
                            <path d="M47.5414562,35.7155666 L0.737543761,35.7155666 C0.330050833,35.7155666 0,35.3720663 0,34.947968 L3.22273207,30.1330636 L44.9752453,30.1330636 L48.279,34.947968 C48.279,35.3720663 47.9489492,35.7155666 47.5414562,35.7155666 Z"></path>
                        </g>
                        <line
                            x1="28.2673202"
                            y1="14.1259738"
                            x2="30.377888"
                            y2="14.1259738"
                            stroke="#FFFFFF"
                            strokeWidth="2.002"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></line>
                    </g>
                </g>
            </g>
        </svg>
    );
}
